export default function getCustomListEntitiesUrl(args: {
  listId: string;
}): string {
  const { listId } = args;
  return `/api/customEntityLists/${listId}/entities`;
}
